import React from "react";

import { FieldError } from "../billing/stripe-split-form";

import { ICON_PRICE_IN_DOLLARS } from "./constants";
import {
    clearQuantityToAddInputError,
    handleQuantityInputChange,
    resetForm,
} from "./actionCreators";

const BalanceInputSection = ({ state, dispatch }) => {
    const handleQuantityToAddInputChange = (e) => {
        dispatch(clearQuantityToAddInputError());

        const formattedValue = e.target.value.replace(/\./g, "");
        dispatch(
            handleQuantityInputChange({
                quantityToAdd: formattedValue,
            })
        );

        if (state.balancePurchased) {
            dispatch(resetForm());
        }
    };

    return (
        <fieldset className="balance-input-section">
            <h4>Number of Icons to Add</h4>
            <div className="price-per-icon">
                Enter 2 to 100 icons to add to your prepaid wallet balance ($
                {ICON_PRICE_IN_DOLLARS} per icon).
            </div>
            <ol className="alpha">
                <li>
                    <input
                        className={`input ${
                            state.quantityToAddInput.error && "error"
                        }`}
                        type="number"
                        max="100"
                        min="2"
                        value={state.quantityToAddInput.value}
                        onChange={handleQuantityToAddInputChange}
                        disabled={state.processingRequest}
                    />
                    {state.quantityToAddInput.error ? (
                        <FieldError error={state.quantityToAddInput.error} />
                    ) : (
                        <p className="text">
                            Enter the amount of icons you need and future Pro
                            Downloads will subtract from your prepaid balance.
                        </p>
                    )}
                </li>
            </ol>
        </fieldset>
    );
};

export default BalanceInputSection;
